import React from 'react';
import './Research.css';

const Research = () => {
  const researchAreas = [
    {
      title: "Research Areas",
      description: "This section is under construction. Detailed information about CIP research themes will be added soon.",
      projects: ["Area details coming soon", "Additional updates will be posted here"]
    },
    {
      title: "Ongoing Projects",
      description: "Project summaries and current research initiatives will be published here once they are ready for release.",
      projects: ["Project information coming soon", "More updates will be shared here"]
    },
    {
      title: "Collaborative Work",
      description: "Information about interdisciplinary collaborations and partner activities is being prepared.",
      projects: ["Collaboration highlights coming soon", "Partner research updates coming soon"]
    },
    {
      title: "Research Outputs",
      description: "Publications, outcomes, and featured achievements will be listed here in a future update.",
      projects: ["Research output details coming soon", "Featured work will appear here"]
    }
  ];

  return (
    <div className="research-container">
      <h1 className="research-header">Research</h1>
      
      <section className="research-overview">
        <h2>Research Overview</h2>
        <p>
          This page is under construction. Official information about research
          activities at CIP will be published here soon.
        </p>
      </section>

      <section className="research-areas">
        <h2>Research Areas</h2>
        <div className="research-grid">
          {researchAreas.map((area, index) => (
            <div key={index} className="research-card">
              <h3>{area.title}</h3>
              <p>{area.description}</p>
              <div className="project-list">
                <h4>Coming Soon:</h4>
                <ul>
                  {area.projects.map((project, pIndex) => (
                    <li key={pIndex}>{project}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="research-collaboration">
        <h2>Research Collaboration</h2>
        <p>
          Collaboration information and contact details for research enquiries
          are currently being updated.
        </p>
        <button className="contact-button" disabled>Details Coming Soon</button>
      </section>
    </div>
  );
};

export default Research; 
